/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Person } from "~/generated/graphql";

export function prepareRows(
  people: Person[],
  stateQuery: { page: number; limit: number; query?: string }
) {
  const { page, limit, query = "" } = stateQuery;

  const filteredPeople = people.filter((person) =>
    query.length > 2
      ? JSON.stringify(person).match(new RegExp(query, "i"))
      : true
  );

  const pageRows = filteredPeople.slice(page * limit, limit + page * limit);

  return {
    pageRows,
    totalCount: filteredPeople.length,
  };
}
